import { takeLatest, put, call, fork } from "redux-saga/effects";
import { QuestionareService } from "services";

import {
    fetchedQuestionare,
    // failedFetchQuestionare,
    fetchedAnswers,
    failedFetchAnswers,
    updatedAnswersForQuestionare,
    failedUpdateAnswersForQuestionare
} from "store/actions";
import { Questionnaires } from "constants/questionaire_list";
import { QUESTIONARE_ACTIONS } from "constants";

function* fetchQuestionare() {
    const { data, error } = yield call(QuestionareService.getQuestionare);
    if (!error && data) {
        yield put(fetchedQuestionare(Questionnaires));
    } else {
        yield put(fetchedQuestionare(Questionnaires));
        // yield put(failedFetchQuestionare(error));
    }
}

function* fetchAnswers({ payload: { caseId } }) {
    const { data, error } = yield call(
        QuestionareService.getAnswersForQuestionare,
        caseId
    );
    if (!error) {
        yield put(fetchedAnswers(caseId, data));
    } else {
        yield put(failedFetchAnswers(caseId, error));
    }
}

function* updateAnswersForQuestionare({ payload: { caseId, data } }) {
    const { val, error } = yield call(
        QuestionareService.postAnswersForQuestionare,
        caseId,
        data
    );
    if (!error) {
        yield put(updatedAnswersForQuestionare(caseId, val));
    } else {
        yield put(failedUpdateAnswersForQuestionare(caseId, error));
    }
}

export default fork(function*() {
    yield takeLatest(QUESTIONARE_ACTIONS.FETCH_QUESTIONARE, fetchQuestionare);
    yield takeLatest(
        QUESTIONARE_ACTIONS.FETCH_ANSWERS_FOR_QUESTIONARE,
        fetchAnswers
    );
    yield takeLatest(
        QUESTIONARE_ACTIONS.UPDATE_QUESTIONARE_ANSWER,
        updateAnswersForQuestionare
    );
});
